import { useState } from 'react'
import styles from './styles.module.css'
import InputMask from 'react-input-mask'
import { motion } from 'framer-motion'
import { notifyErrorCustom } from '../../../utils/notify'

import { PreviousPass } from '../../../components/PreviousPass'
import { useTranslation } from 'react-i18next'

function StepPhone({ phone, setPhone, setStep }) {
  const STEPS = {
    STEP_PASS_EMAIL: 'stepEmail',
    STEP_PASS_PASSWORD: 'stepPassword',
  }

  const stepsArray = [
    {
      pass: '1º Passo',
      title: 'Nome e Sobrenome',
      current: true
    },
    {
      pass: '2º Passo',
      title: 'Email',
      current: true
    },
    {
      pass: '3º Passo',
      title: 'Telefone',
      current: true
    },
    {
      pass: '4º Passo',
      title: 'Senha',
      current: false
    },
    {
      pass: '5º Passo',
      title: 'CPF',
      current: false
    },
    {
      pass: '6º Passo',
      title: 'Endereço',
      current: false
    },
  ];

  const handleNavigate = async (type) => {
    if (type === 'next') {

      if(phone === ''){
        notifyErrorCustom(t('fast_publishing_phone_enter_your_phone_alert'))
        return
      }
      setStep(STEPS.STEP_PASS_PASSWORD)
    } else {
      setStep(STEPS.STEP_PASS_EMAIL)
    }
  }

  const formatPhone = (value) => {
    

    // Remove caracteres não numéricos do valor
    const cleanedValue = value.replace(/\D/g, '')

    // Aplica a máscara de telefone (xx) xxxxx-xxxx
    let formattedValue = ''
    if (cleanedValue.length >= 2) {
      formattedValue += `(${cleanedValue.substring(0, 2)}`
    }
    if (cleanedValue.length > 2) {
      formattedValue += `) ${cleanedValue.substring(2, 7)}`
    }
    if (cleanedValue.length > 7) {
      formattedValue += `-${cleanedValue.substring(7, 11)}`
    }

    
    return formattedValue
  }

  const handlePhoneChange = (event) => {
    const inputValue = event.target.value
    const formattedPhone = formatPhone(inputValue)
    setPhone(formattedPhone)
  }

  const {t} = useTranslation();

  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      style={{
        width: '100%',
        // height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className={styles.box_step}>
        {/* <PreviousPass steps={stepsArray}/> */}

        <div className={styles.box_page}>
          <p style={{ margin: '0px' }}>{t("fast_publishing_register_title")}</p>
          <h1 style={{ marginTop: '0px', fontSize: '45px', fontWeight: 500 }}>{t("fast_publishing_create_account")}</h1>

          <div className={styles.box_input_phone}>
            <p>{t("fast_publishing_phone_subtitle")}</p>
            {/* <input
          className={styles.input_phone}
          type="text"
          placeholder="Telefone"
          value={phone}
          onChange={(e) => setPhone(e.currentTarget.value)}
        /> */}
            <InputMask
              className={styles.input_phone}
              type="text"
              mask="(99) 99999-9999"
              placeholder="(00) 00000-0000"
              value={phone}
              onChange={(e) => setPhone(e.currentTarget.value)}
            />
          </div>
        </div>
        <div className={styles.box_button}>
          <button
            className={styles.back_button}
            onClick={() => handleNavigate('back')}
          >
           {t("back_buttom")}
          </button>
          <button
            className={styles.next_button}
            onClick={() => handleNavigate('next')}
          >
          {t("next_buttom")}
          </button>
        </div>
      </div>
    </motion.div>
  )
}

export default StepPhone
